function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Tab } from 'react-bootstrap';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import classNames from 'classnames';
import { SupportContent } from 'moduleBaseMenu/components/desktop/SupportContent';
import { ToolsContent } from 'moduleBaseMenu/components/desktop/ToolsContent';
import { FaqContent } from 'moduleBaseMenu/components/desktop/FaqContent';

var TabsContent = function TabsContent(_ref) {
  var blocks = _ref.blocks,
      activeId = _ref.activeId,
      supportInfo = _ref.supportInfo,
      tools = _ref.tools,
      faq = _ref.faq;
  var items = blocks.map(function (block) {
    var menuItems = block.items.map(function (menuItem) {
      var subMenu = {
        items: menuItem.items,
        className: 'list-unstyled',
        linkHolderClassName: 'd-flex align-items-center',
        linkClassName: 'text-truncate'
      };
      var subMenuDynamic = {
        blocks: menuItem.blocks,
        items: menuItem.dynamicItems,
        className: 'list-unstyled',
        linkHolderClassName: 'd-flex align-items-center',
        linkClassName: 'text-truncate'
      };
      return /*#__PURE__*/React.createElement("li", {
        className: classNames({
          'd-flex align-items-center': !menuItem.items
        }),
        key: menuItem.label
      }, /*#__PURE__*/React.createElement(MenuItem, _extends({}, menuItem, {
        className: "d-flex align-items-center",
        subMenu: subMenu,
        subMenuDynamic: subMenuDynamic,
        activeId: activeId
      })));
    });
    return /*#__PURE__*/React.createElement(Tab.Pane, {
      eventKey: block.id,
      key: block.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "fs-22 mb-4 pb-3"
    }, block.label), /*#__PURE__*/React.createElement("ul", {
      className: "desktop-nav-list"
    }, menuItems));
  });
  return /*#__PURE__*/React.createElement(Tab.Content, {
    className: "mb-48p"
  }, items, /*#__PURE__*/React.createElement(SupportContent, {
    supportInfo: supportInfo
  }), /*#__PURE__*/React.createElement(ToolsContent, {
    tools: tools
  }), /*#__PURE__*/React.createElement(FaqContent, {
    faq: faq
  }));
};

export { TabsContent };